export function displayMovementName(movement, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  if (movement && movement.langs) {
    const langsAry = movement.langs
    let matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === locale)
    if (!matchedLangObj && locale !== 'en-us') {
      matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === 'en-us')
    }
    if (!matchedLangObj && langsAry.length > 0) {
      matchedLangObj = langsAry[0]
    }
    return (matchedLangObj && matchedLangObj.name) || ''
  }
  return (movement && movement.name) || ''
}

export function displayMovementDescription(movement, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  if (movement && movement.langs) {
    const langsAry = movement.langs
    let matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === locale)
    if (!matchedLangObj && locale !== 'en-us') {
      matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === 'en-us')
    }
    if (!matchedLangObj && langsAry.length > 0) {
      matchedLangObj = langsAry[0]
    }
    return (matchedLangObj && matchedLangObj.description) || ''
  }
  return (movement && movement.description) || ''
}
